module.exports = __webpack_public_path__ + "static/img/static/img/pre_min.6e999ba5.png";